'use strict';
/**
 * Get any configuration from the API.
 * This returns a promise, as the config may not have already loaded.
 * Use:
 * msConfig('propToGet').then(function(propToGet) { ... })
 */

angular.module('msCore').service('msConfig', ['$q', '$http', '$log', function ($q, $http, $log) {
  var config;
  var request;
  if (window.__karma__) {
    config = {
      isProduction: false,
      version: 'test',
      humanaVitalityCallbackUrl: ''
    };
  }
  if (window.MYSTRENGTH && window.MYSTRENGTH.config) {
    config = window.MYSTRENGTH.config;
  }
  return function (value) {
    /** Get the value out of config, or throw an error if it's not in there */
    function extractValue() {
      if (!value) {
        return config;
      }
      if (value === 'features') {
        // Accommodating web features new structure
        // - config.config.platforms.web.features
        if (!config.platforms.web.hasOwnProperty(value)) {
          $q.reject('Config did not contain value');
        }
        return config.platforms.web[value];
      } else {
        if (!config.hasOwnProperty(value)) {
          $q.reject('Config did not contain value');
        }
        return config[value];
      }
    }
    // config has already been fetched
    if (config) {
      return $q.when(extractValue());
    }
    // we haven't requested the config yet, do so
    if (!request) {
      // cache the request so we dont send it twice while waiting
      request = $http.get('/apiproxy/config').then(function (response) {
        config = response.data;
        $log.info('Configuration', config);
      });
    }
    return request.then(extractValue, function () {
      $log.error('Failed to load config', value);
      request = null;
    });
  };
}]);